import { useState } from "react";
import { useAtom } from "jotai";
import PVIncentive from "./PVIncentive";
import PVConfigure from "./PVConfigure";
import PVUpload from "./PVUpload";
import { componentsAtom } from "../../utils/atoms/componentsAtom";

const PvTabOverview = (props) => {
  const { form, updatePVData, incentivesData, activeTab } = props;
  const [componentDetails] = useAtom(componentsAtom);
  const [isLoading, setIsLoading] = useState(false);

  return (
    <>
      <PVUpload
        stepName="step1"
        updateData={(data) => updatePVData("uiAttributes", "pvSetup", data)}
        selectedValue={
          componentDetails?.pv?.uiAttributes?.pvParameters?.pvSetup?.toLocaleLowerCase() ||
          "new"
        }
      />
      <PVConfigure
        stepName="step2"
        updatePVData={updatePVData}
        form={form}
        componentDetails={componentDetails}
        isLoading={isLoading}
        setIsLoading={setIsLoading}
      />
      {componentDetails?.pv?.uiAttributes?.pvParameters?.pvSetup === "new" && (
        <div
          className={
            activeTab === 0 ? "enable-incentives" : "disable-incentives"
          }
        >
          <PVIncentive
            stepName="step3"
            form={form}
            updateData={(data) => updatePVData("incentives", data)}
            componentDetails={componentDetails}
            incentivesData={incentivesData}
          />
        </div>
      )}
    </>
  );
};

export default PvTabOverview;
